import { ENV } from '~/utils/env';
import { sha256 } from '~/utils/sha256';

export const PAYMONTHS_ACCESS_KEY = {
  prod: '01JF76PQSQ754HAHNNE22SG8CZ',
  stg: '01JF76PQSQ754HAHNNE22SG8CZ',
  dev: '01JAEMKV10VWTRWS64PYRYDH3K',
}[ENV];

export const PAYMONTHS_ACCESS_KEY_HASH = sha256(PAYMONTHS_ACCESS_KEY);
